// @flow

import React from 'react';
import { withRouter } from 'react-router-dom';
import type { Media } from '../../types/keepeekType';
import { isMobile } from '../../const';

type Props = {
  medias: Media[];
}

type State = {}

class KeepeekMediaPanoramic extends React.Component<Props, State> {
  pannellumViewer = null;

  componentDidMount() {
    this.fetchKeepeekMediaIntoComponent(this.props.medias);
  }

  shouldComponentUpdate(nextProps: Props): boolean {
    if (this.props.medias !== nextProps.medias) {
      this.fetchKeepeekMediaIntoComponent(nextProps.medias);
    }
    return true;
  }

  componentWillUnmount() {
    if (this.pannellumViewer) {
      this.pannellumViewer.destroy();
    }
  }

  fetchKeepeekMediaIntoComponent = (medias: Media[]) => {
    if (medias) {
      const mediaArr = [
        this.getMediaByName(this.props.medias, 'pano_f'),
        this.getMediaByName(this.props.medias, 'pano_r'),
        this.getMediaByName(this.props.medias, 'pano_b'),
        this.getMediaByName(this.props.medias, 'pano_l'),
        this.getMediaByName(this.props.medias, 'pano_u'),
        this.getMediaByName(this.props.medias, 'pano_d'),
      ];
      if (this.pannellumViewer) {
        this.pannellumViewer.destroy();
      }
      this.pannellumViewer = pannellum.viewer('panorama', {
        type: 'cubemap',
        cubeMap: mediaArr,
        autoLoad: true,
      });
    }
  };

  getMediaByName = (mediaList: Media[], title: string) => {
    const media = mediaList.filter(elt => elt.title === title)[0];
    if (media) {
      return media.fullscreen;
    }
    return null;
  };

  render() {
    return (
      <div className="image-360-container" id="panorama"></div>
    );
  }
}

export default withRouter(KeepeekMediaPanoramic);
